export default (() => {
    const scrollTo = document.querySelectorAll( '.scroll-to' )

    if ( !scrollTo.length ) {
        return
    }

    scrollTo.forEach(elem => {

        function scrollToElement(event) {
            let clickTarget

            if (event.target.classList.contains('scroll-To')) {
                clickTarget = event.target
            } else {
                clickTarget = event.target.closest('.scroll-to')
            }

            const hash = clickTarget.hash.substr(1)
            const target = document.getElementById( hash )

            if ( target !== null ) {
                event.preventDefault()

                target.scrollIntoView({
                    behavior: 'smooth'
                })

                document.getElementById('hamburger__toggle').checked = false
            }
        }

        elem.addEventListener( 'click', function ( event ) {
            scrollToElement(event)
        }, false)

        elem.addEventListener( 'keypress', function ( event ) {
            if (e.key === 'Enter') {
                scrollToElement(event)
            }
        }, false)
    })
})()
